import { mutatorAction } from "satcheljs";
import { shiftRequestsPanelStore } from "../";

export default mutatorAction('SET_ERROR_MESSAGE', function setErrorMessageInStore(errorMessage: string, showRefreshButton: boolean) {
    shiftRequestsPanelStore().errorMessage = errorMessage;
    shiftRequestsPanelStore().messageBarShowRefreshButton = showRefreshButton;
});
